module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "columns is-vcentered",
    attrs: {
      "id": "verifyEmailFormContainer"
    }
  }, [_c('div', {
    staticClass: "column is-6 is-offset-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/eurotrader_logo_rgb_purple.svg")
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.activeMessage === 'already-verified') ? _c('div', {
    staticClass: "box-text"
  }, [_vm._v("\n          " + _vm._s(_vm.$t("your_email_is_verified")) + "\n          "), _c('p', [_c('router-link', {
    attrs: {
      "to": '/' + _vm.Language + '/login'
    }
  }, [_vm._v(_vm._s(_vm.$t("click_here_to_login")))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.activeMessage === 'success') ? _c('div', {
    staticClass: "box-text"
  }, [_vm._v("\n          " + _vm._s(_vm.$t("success_email_verified")) + "\n          "), _c('p', [_c('router-link', {
    attrs: {
      "to": '/' + _vm.Language + '/login'
    }
  }, [_vm._v(_vm._s(_vm.$t("click_here_to_login")))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.activeMessage === 'expired') ? _c('div', {
    staticClass: "box-text"
  }, [_vm._v("\n          " + _vm._s(_vm.$t("your_link_expired")) + "\n          "), _c('p', [_c('a', {
    on: {
      "click": _vm.requestEmailVerification
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("click_here_to_request_verification_email")))])])]) : _vm._e(), _vm._v(" "), (_vm.activeMessage === 'new-verification-email-success') ? _c('div', {
    staticClass: "box-text"
  }, [_vm._v(_vm._s(_vm.$t("a_new_verification_link_send")))]) : _vm._e(), _vm._v(" "), (_vm.activeMessage === 'server-error') ? _c('div', {
    staticClass: "box-text"
  }, [_vm._v(_vm._s(_vm.$t("error_contact_support")))]) : _vm._e(), _vm._v(" "), (_vm.activeMessage === 'invalid-request') ? _c('div', {
    staticClass: "box-text"
  }, [_vm._v(_vm._s(_vm.$t("invalid_request_please_check_your_link")))]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-590f6941"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/VerifyEmail.vue
// module id = 769
// module chunks = 0